module.exports = __webpack_public_path__ + "images/statistics-76d45aa4.svg";